<template>
  <div ref="box" class="canvas-box">
    <div ref="canvas" class="canvas" :style="canvasStyle">
      <component v-for="item in $store.state.items" :key="item.id" :is="item.type" :id="item.id" :content="item.content" @input="onInput(item, $event)" />
    </div>
  </div>
</template>

<script>
import TextItem from './TextItem.vue';
import ImageItem from './ImageItem.vue';

export default {
  components: {
    TextItem,
    ImageItem
  },
  data() {
    return {
      mounted: false,
      boxSize: { width: 0, height: 0 }
    };
  },
  mounted() {
    this.resizeObserver = new ResizeObserver(this.updateCanvasSize);
    this.resizeObserver.observe(this.$refs.box);
    this.updateCanvasSize();
    this.mounted = true;
  },
  destroyed() {
    this.resizeObserver.disconnect();
  },
  computed: {
    canvasStyle() {
      if (!this.mounted) {
        return {};
      }
      const fold = this.$store.state.fold;
      if (!fold) {
        return {};
      }
      const pageRatio = fold.width / fold.height;
      const W = this.boxSize.width;
      const H = this.boxSize.height;
      if (!W || !H) {
        return {};
      }
      const boxRatio = W / H;
      // Fit the fold's aspect ratio inside the box — whichever side hits first wins.
      if (boxRatio < pageRatio) {
        // Fold is wider than the box — fill width, derive height.
        return { width: `${W}px`, height: `${W / pageRatio}px` };
      }
      // Fold is taller than (or equal to) the box — fill height, derive width.
      return { height: `${H}px`, width: `${H * pageRatio}px` };
    }
  },
  methods: {
    onInput(item, content) {
      this.$store.commit('updateItem', { item, content });
    },
    updateCanvasSize() {
      const boxEl = this.$refs.box;
      if (!boxEl) {
        return;
      }
      const boxRect = boxEl.getBoundingClientRect();
      this.boxSize = {
        width: boxRect.right - boxRect.left,
        height: boxRect.bottom - boxRect.top
      };
      this.$store.commit('setCanvasBoxSize', this.boxSize);
      // Wait a tick so canvasStyle can update before we measure the inner canvas.
      this.$nextTick(() => {
        const canvasEl = this.$refs.canvas;
        if (!canvasEl) {
          return;
        }
        const canvasRect = canvasEl.getBoundingClientRect();
        this.$store.commit('setCanvasSize', {
          width: canvasRect.right - canvasRect.left,
          height: canvasRect.bottom - canvasRect.top
        });
      });
    }
  }
}
</script>

<style scoped>
  .canvas-box {
    flex-grow: 1.0;
    background-color: inherit;
    position: relative;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .canvas {
    background-color: white;
    position: relative;
    overflow: hidden;
  }
</style>
